module.exports = __webpack_public_path__ + "static/Moderat-Regular-9f8cb476f2fc30693305451ed3b0cd70.eot";